module.exports = __webpack_public_path__ + "6ec8dbd9482984f19e7dffc327aa2cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/sale-banner-huetrade.jpg
// module id = ./assets/images/sale-banner-huetrade.jpg
// module chunks = 0